import { render } from "./Investors.vue?vue&type=template&id=eb3905c2&scoped=true"
import script from "./Investors.vue?vue&type=script&lang=js"
export * from "./Investors.vue?vue&type=script&lang=js"

import "./Investors.vue?vue&type=style&index=0&id=eb3905c2&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-eb3905c2"

export default script